// Tipos base
export interface Parceiro {
  tipo: 'ICT Pública' | 'Fundação de Apoio' | string;
  razaoSocial: string;
  cnpj: string;
  endereco: string;
  representanteLegal: string;
  cargoRepresentante: string;
  telefone: string;
  email: string;
}

export interface Fundacao extends Parceiro {
  apelido: 'FASTEF' | 'FCPC' | string;
}

// ===== 1) Dados fixos para o 1º Parceiro (UFC) =====
export const PARCEIRO_UFC: Parceiro = {
  tipo: 'ICT Pública',
  razaoSocial: 'Universidade Federal do Ceará – UFC',
  cnpj: '07.272.636/0001-31',
  endereco: 'Av. da Universidade, nº 2853 – Benfica, Fortaleza/CE – CEP 60020-181',
  representanteLegal: 'Magnífico Reitor(a)',
  cargoRepresentante: 'Reitor(a) da Universidade Federal do Ceará',
  telefone: "(85) 3366-7330",
  email: "coordenacao.ufcinforma@ufc.br"
};

// ===== 2) Dados fixos para as Fundações =====
export const FUNDACAO_FASTEF: Fundacao = {
  apelido: 'FASTEF',
  tipo: 'Fundação de Apoio',
  razaoSocial: 'ASTEF – FUNDAÇÃO DE APOIO A SERVIÇOS TÉCNICOS, ENSINO E FOMENTO A PESQUISAS',        
  cnpj: '08.918.421/0001-08',                       
  endereco: 'Universidade Federal do Ceará - Centro de Tecnologia - Campus do Pici - Bloco 710 – Sala B - Pici, Fortaleza - CE, 60440-900',                   
  representanteLegal: '',   
  cargoRepresentante: '',
  telefone: "(85) 3217-1282",
  email: "fundacao@fastef.ufc.br"
};

export const FUNDACAO_FCPC: Fundacao = {
  apelido: 'FCPC',
  tipo: 'Fundação de Apoio',
  razaoSocial: 'Fundacao Cearense de Pesquisa e Cultura', 
  cnpj: '05.330.436/0001-62',                                     
  endereco: 'Avenida Universidade, 2995 - Benfica, Fortaleza - CE, 60.020-181',                                   
  representanteLegal: '',                 
  cargoRepresentante: '',  
  telefone: "(85) 3521-3400",
  email: "secretaria@fcpc.ufc.br"              
};

// ===== 3) Textos da UI centralizados =====
export const UI_TEXTS = {
  resetButton: 'Limpar preenchimento atual',
  autofillUFCButton: 'Preencher com Dados da UFC',
  autofillFASTEFButton: 'Preencher com dados da FASTEF',
  autofillFCPCButton: 'Preencher com dados da FCPC',
};

// ===== 4) Textos de ajuda das seções =====
export const HELP_TEXTS: Record<string, string> = {
  'sec-identificacao':
    'Preencha os dados completos de todos os parceiros envolvidos no acordo (razão social, CNPJ, endereço, representante legal e contatos).',

  'sec-identificacao-ict':
    'Informe os dados institucionais da ICT pública (UFC), sempre com base em registros oficiais e atualizados da instituição.',

  'sec-identificacao-parceiro2':
    'Descreva com atenção o parceiro externo (empresa, órgão ou instituição), garantindo que os dados de identificação estejam corretos.',

  'sec-identificacao-fundacao':
    'Cadastre a fundação de apoio responsável pela gestão administrativa e financeira do projeto, conforme o convênio firmado.',

  'sec-identificacao-coordenacao-ufc':
    'Indique quem será o(a) coordenador(a) do projeto pela UFC, com dados de contato que facilitem a comunicação durante a execução.',

  'sec-identificacao-coordenacao-parceiro':
    'Informe o(a) coordenador(a) indicado pelo parceiro externo, que fará a interlocução com a UFC ao longo do projeto.',

  'sec-objeto':
    'Descreva, em poucas linhas, o que é o projeto: qual problema aborda, qual produto ou resultado principal será entregue e para quem.',

  'sec-caracterizacao':
    'Explique o contexto do projeto, seus objetivos, público-alvo e a relevância científica, tecnológica, social ou econômica.',

  'sec-obj-gerais':
    'Apresente o objetivo geral do projeto de forma ampla, indicando a transformação ou resultado principal que se pretende alcançar.',

  'sec-obj-especificos':
    'Liste objetivos específicos claros e mensuráveis, detalhando os passos necessários para atingir o objetivo geral.',

  'sec-justificativa':
    'Explique por que o projeto é importante, quais demandas atende, quais lacunas preenche e quais benefícios poderá gerar.',

  'sec-desc-atividades':
    'Apresente, de forma resumida, como o trabalho será realizado, destacando as principais frentes de atuação da UFC, do parceiro e em conjunto.',

  'sec-desc-atividades-ufc':
    'Descreva as atividades que ficarão sob responsabilidade da UFC, destacando etapas, entregas e eventuais dependências.',

  'sec-desc-atividades-parceiro':
    'Detalhe as atividades a serem executadas pelo parceiro, alinhadas aos objetivos do projeto e às suas competências.',

  'sec-desc-atividades-conjuntas':
    'Liste as atividades que exigem atuação integrada entre UFC e parceiro, indicando como será feita a cooperação.',

  'sec-direitos-pi':
    'Defina como serão tratados os direitos de propriedade intelectual: titularidade, copropriedade, repartição de receitas e licenciamento.',

  'sec-resultados':
    'Descreva os resultados esperados (produtos, serviços, processos, publicações, protótipos etc.) e, quando possível, vincule-os a indicadores.',

  'sec-meios':
    'Explique quais meios humanos, financeiros e de infraestrutura serão necessários para viabilizar o projeto.',

  'sec-meios-rh':
    'Cadastre todas as pessoas envolvidas do lado do parceiro, indicando funções no projeto.',
  
  'sec-meios-rh-ufc':
    'Cadastre todas as pessoas envolvidas do lado da ufc, indicando funções no projeto.',

  'sec-meios-financeiros':
    'Descreva os recursos financeiros previstos, sua origem e forma de aplicação, alinhando-os ao plano de aplicação financeira.',

  'sec-meios-infra':
    'Indique os espaços físicos, laboratórios, equipamentos e demais estruturas que serão utilizados durante o projeto.',

  'sec-plano-financeiro':
    'Preencha o detalhamento dos custos do projeto, organizando itens, quantidades, valores e fontes de recurso em cada tabela orçamentária.',
};
